export type RawStatus =
  | string
  | { status?: string; date?: string; time?: string }
  | Array<{ status?: string; date?: string; time?: string } | string>
  | null
  | undefined;

export function getApplicationStatus(status: RawStatus): string {
  if (typeof status === "string") {
    return status;
  }

  if (Array.isArray(status)) {
    for (let index = status.length - 1; index >= 0; index -= 1) {
      const item = status[index];

      if (typeof item === "string") {
        return item;
      }

      if (item && typeof item === "object" && typeof item.status === "string" && item.status.trim()) {
        return item.status;
      }
    }
    return "";
  }

  if (status && typeof status === "object" && typeof status.status === "string") {
    return status.status;
  }

  return "";
}

export function normalizeStatus(status: RawStatus): string {
  return getApplicationStatus(status).trim().toUpperCase();
}

export function getStatusDisplayValue(status: RawStatus): string {
  const value = getApplicationStatus(status).trim();
  return value || "Pending";
}